import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { TimeClock } from "../interfaces/timeclock.interface";

@Injectable({providedIn: "root"})
export class ClockInService {
    private clockInUpdated: Subject<TimeClock> = new Subject<TimeClock>();

    getTimeClockUpdates(): Observable<TimeClock> {
        return this.clockInUpdated.asObservable();
    }

    updateTimeClock(timeClock: TimeClock): void {
        this.clockInUpdated.next(timeClock);
    }

}